/**
 * CardBody Component
 *
 * Body sub-component for compound Card API
 * Provides flexible content area with collapsible support
 */

import React from 'react';
import { cx } from '@/styled-system/css';
import { cardBody } from './card.styles';
import type { CardBodyProps } from './types';

export const CardBody = React.forwardRef<HTMLDivElement, CardBodyProps>(
  ({ children, className, ...restProps }, ref) => {
    return (
      <div ref={ref} className={cx(cardBody, className)} {...restProps}>
        {children}
      </div>
    );
  },
);

CardBody.displayName = 'CardBody';

export type { CardBodyProps };
